import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mediaQuery } from '@/assets/styles/util/media-query';

const fullpageLayout = css`
  border-radius: 0;
  height: calc(100vh - 57px);
  .error-popup_close-ico {
    margin-bottom: 0px;
  }
  .error-popup_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const ErrorPopupStyle = styled.div`
  ${({
    theme: {
      palette: {
        common: { white },
      },
      typography: {
        weight: { weight900 },
        size: { size90, size115 },
      },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${mediaQuery({
      maxWidth: [null, 400],
      minWidth: [null, 250],
      backgroundColor: [null, white],
      borderRadius: [null, 16],
      padding: ['1rem 1.5rem 1.5rem 1.5rem', '1.5rem'],
    })}

    &.full-page {
      border-radius: 0;
      height: calc(100vh - 73px);
      justify-content: center;
      position: relative;
      .error-popup_image {
        margin-bottom: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          max-width: 183px;
        }
      }
    }

    .error-popup_title {
      font-size: ${size115};
      font-weight: ${weight900};
      text-align: center;
      margin-bottom: 1rem;
    }

    .error-popup_subtitle {
      font-size: ${size90};
      text-align: center;
      margin-bottom: 1.5rem;
    }

    .error-popup_action {
      width: 100%;
    }

    .error-popup_action-single {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        max-width: 200px;
        min-width: 150px;
      }
    }

    .error-popup_action-multiple {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        max-width: 150px;
        flex: 1;
        &:first-of-type {
          margin-right: 10px;
        }
        &:last-child {
          margin-right: 10px;
        }
      }
    }
  `}
`;

export const MultipleButtonErrorPopupStyle = styled.div`
  ${({
    theme: {
      palette: {
        common: { white },
        mist,
      },
      typography: {
        weight: { weight900 },
      },
    },
  }) => css`
    display: flex;
    flex-direction: column;

    &.full-page {
      ${fullpageLayout}
    }

    ${mediaQuery({
      maxWidth: [null, 400],
      minWidth: [null, 250],
      backgroundColor: [null, white],
      borderRadius: [null, 16],
      padding: ['0rem 1.5rem 1.5rem 1.5rem', '1.5rem'],
    })}

    .error-popup_message {
      display: flex;
    }

    .error-popup_close-ico {
      margin-bottom: 20px;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
    }

    .error-popup_exclamation-ico {
      margin-right: 1rem;
    }

    .error-popup_title {
      font-size: 18px;
      font-weight: ${weight900};
      text-align: left;
      margin-bottom: 1rem;
      color: ${mist.contrast100};
    }

    .error-popup_subtitle {
      font-size: 14px;
      text-align: left;
      margin-bottom: 1.5rem;
      color: ${mist.contrast70};
    }

    .error-popup_action {
      width: 100%;
    }

    .error-popup_action-single {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        max-width: 200px;
        min-width: 150px;
      }
    }

    .error-popup_action-multiple {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        max-width: 150px;
        flex: 1;
        &:first-of-type {
          margin-right: 10px;
        }
        &:last-child {
          margin-right: 10px;
        }
      }
    }
  `}
`;

export const SingleButtonErrorPopupStyle = styled.div`
  ${({
    theme: {
      palette: {
        common: { white },
        mist,
      },
      typography: {
        weight: { weight900 },
      },
    },
  }) => css`
    display: flex;
    flex-direction: column;

    &.full-page {
      ${fullpageLayout}
    }

    ${mediaQuery({
      maxWidth: [null, 400],
      minWidth: [null, 250],
      backgroundColor: [null, white],
      borderRadius: [null, 16],
      padding: ['0rem 1.5rem 1.5rem 1.5rem', '1.5rem'],
    })}

    .error-popup_message {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .error-popup_close-ico {
      margin-bottom: 20px;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
    }

    .error-popup_image {
      margin-bottom: 1rem;
    }

    .error-popup_title {
      font-size: 18px;
      font-weight: ${weight900};
      text-align: center;
      margin-bottom: 1rem;
      color: ${mist.contrast100};
    }

    .error-popup_subtitle {
      font-size: 14px;
      text-align: center;
      margin-bottom: 1.5rem;
      color: ${mist.contrast70};
    }

    .error-popup_action {
      width: 100%;
    }

    .error-popup_action-single {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        width: 100%;
      }
    }
  `}
`;
